// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"202":"d3c9e9d4","418":"836fefd0"}[chunkId] + ".chunk.css";
};